var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaimIconLargeApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 70,
    viewBox: "0 0 69 70",
    width: 69,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-230-145h1200v1625h-1200z",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#ebfbee",
    height: 70,
    rx: 4,
    width: 69
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 56c-1.6568542 0-3-1.3431458-3-3v-36c0-1.6568542 1.3431458-3 3-3h28c1.6568542 0 3 1.3431458 3 3v36c0 1.6568542-1.3431458 3-3 3zm4-34c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h8c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1zm0 16c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h17c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1zm0 4c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h20c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1zm0 4c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1h15c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1z",
    fill: "#8ce99a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "#69db7c",
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.9129464 15.2678863c-.3437517.3356965-.7433013.5035423-1.1986607.5035423s-.85490898-.1678458-1.1986607-.5035423l-2.40401786-2.3411444c-.1696437-.1700281-.25446428-.3662114-.25446428-.5885558 0-.2223445.0870527-.4185278.26116071-.5885559.16964371-.1656684.36830243-.2485014.59598214-.2485014s.42857056.082833.60267858.2485014l2.39732141 2.3476839 5.3973214-5.27738417c.1741081-.1656684.3749989-.24850136.6026786-.24850136s.4285706.08283296.6026786.24850136c.1696437.1700281.2544643.36621143.2544643.58855586 0 .22234444-.0848206.41852776-.2544643.58855586z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimIconLargeApproved);
export default __webpack_public_path__ + "static/media/claim-icon-large-approved.26cec18f839cea8a7f3b11c226962595.svg";
export { ForwardRef as ReactComponent };